import { useSyncExternalStore } from 'react'

/**
 * 指定した ref 要素がクランプ（省略）されているかどうかを判定する
 *
 * - 要素の scrollHeight と clientHeight を比較し、視覚的に省略されている場合に true を返す
 *   - 例: line-clamp や max-height + overflow: hidden などによって省略されている場合
 * - 判定は window の resize に応じて再評価される
 */
export function useIsRefClamped(ref: React.RefObject<HTMLElement>) {
  return useSyncExternalStore(
    (onChange) => {
      window.addEventListener('resize', onChange)
      return () => window.removeEventListener('resize', onChange)
    },
    () => {
      const e = ref.current
      if (e === null) {
        return false
      }
      return e.scrollHeight > e.clientHeight
    },
    () => false
  )
}
